// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__1EtoX","inputDescription":"styles_inputDescription__2F4X1"};